import { render } from "./SmartHospital.vue?vue&type=template&id=87a370c4&scoped=true"
import script from "./SmartHospital.vue?vue&type=script&lang=js"
export * from "./SmartHospital.vue?vue&type=script&lang=js"

import "./SmartHospital.vue?vue&type=style&index=0&id=87a370c4&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87a370c4"]])

export default __exports__